/* Pretty Driven accessibility helpers */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.pd-skip-link[href="#MainContent"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var main = document.getElementById('MainContent');
      if (!main) return;
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      window.setTimeout(function () { main.focus({ preventScroll: true }); }, 0);
    });
  });
});
